<!-- 添加建筑表单 -->
<template>
    <el-dialog title="选择表计型号" :visible.sync="visible" width="700px" :before-close="handleCloseDialog">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="表计序列号">
                <el-input size="small" v-model="formInline.deviceSerial" clearable placeholder="请输入表计序列号"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" @click="handleSubmit">查询</el-button>
            </el-form-item>
        </el-form>
        <l-table
            :list="tableData"
            :total="total" 
            :otherHeight="500" 
            :options="options"
            :pagination="pagination"
            :columns="columns" 
            :operates="operates"
            @handleSelectionChange="handleSelectionChange"
            @handleSizeChange="handleSizeChange"
            @handleIndexChange="handleIndexChange">
        </l-table>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCloseDialog">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import Service from '@/api/Service'
import lTable from '@/components/lTable/lTable'
import { funFmtOnlineStatus } from '@/utils/utils'
import { base64ToHex,hexToBase64 } from '@/utils/base64ToHex'
export default {
    name:  'CmpChoseMeter',
    props: ["visible", "addForm"],
    data() {
        return {
            formInline: {
                deviceSerial: '',
                page_num: 1,
                page_sum: 10
            },
            tableData: [],
            multipleSelection: [],

            // 
            total: 0,
            otherHeight: 20,
            columns: [
                {
                    prop: 'terminal_serial',
                    label: '表计序列号',
                    align: 'center',
                },
                {
                    prop: 'device_model',
                    label: '表记型号',
                    align: 'center',
                },
				{
				    prop: 'devicebase',
				    label: '十六进制序列号',
				    align: 'center',
				},				
                {
                    prop: 'online_status',
                    label: '在线状态',
                    align: 'center',
                    width: '160',
                    formatter: (row, column, cellValue) => {
                        return this.fmtOnlineStatus(row)
                    }
                },
            ], // 需要展示的列
            operates: {
                width: 200,
                fixed: 'right',
                list: []
            }, // 操作按钮组
            pagination: {
                page_num: 1,
                page_sum: 10
            }, // 分页参数
            options: {
                stripe: true, // 是否为斑马纹 table
                loading: false, // 是否添加表格loading加载动画
                highlightCurrentRow: true, // 是否支持当前行高亮显示
                mutiSelect: true // 是否支持列表项选中功能
            } // table 的参数
      };
    },

    components: { lTable },

    watch: {
        visible(newVal) {
            if(newVal) {
                this.handleInitData();
            }
        }
    },
    mounted() {
        this.handleInitData()
    },

    methods: {
        // 初始化数据
        async handleInitData() {
            if(this.addForm.linked_collector_id === undefined) {
                return
            }
            let params = Object.assign({}, this.pagination, this.addForm);
			let data
			if(this.addForm.linked_collector_id == "directly"){
				data = await Service.getUndirctlyMeter(params);
			}else{data = await Service.getUnbindingMeter(params);}
            if(data) {
                let list = data.list == null ? [] : data.list;
                this.tableData = this.fmtData(list);
                this.total = data.total;
            }
        },
		fmtData(list) {
				return list.map(v=>{
					let obj = {};
					obj["terminal_serial"] = v["terminal_serial"];
					obj["device_model"] = v["device_model"];
					obj["online_status"] = v["online_status"];
					obj['devicebase'] = base64ToHex(v["terminal_serial"]) || "";
					obj['oid'] = v["oid"];
					return obj;
				})
        },		
        // 切换每页显示的数量
        handleSizeChange (pagination) {
            this.pagination = pagination
            this.handleInitData()
        },
        // 切换页码
        handleIndexChange (pagination) {
            this.pagination = pagination
            this.handleInitData()
        },
        // 选中行
        handleSelectionChange (val) {
            this.multipleSelection = val;
        },
        // 关闭弹框
        handleCloseDialog() {
            this.$emit("handleCloseDialog", {flag: false});
        },
        // 确认选择
        handleSave() {
            if(!this.multipleSelection.length){
                this.$notify({
                    title: '警告',
                    message: '请至少勾选一个要添加的表计！',
                    type: 'warning'
                });
                return
            }
            let oids = [];
            let terminal_serial = [];
            this.multipleSelection.map(v=>{
                terminal_serial.push(v.terminal_serial)
                oids.push({oid: v.oid+""})
            })
            let str_terminal = terminal_serial.join(",")
            this.$emit("handleCloseDialog", {flag: true, item: {oids, str_terminal }});
        },
        // 查询表计
        async handleSubmit() {
			if(this.formInline.deviceSerial != '' && this.formInline.deviceSerial.length >= 6){
				this.formInline.deviceSerial = hexToBase64(this.formInline.deviceSerial)
			}
            let form = Object.assign({},this.addForm,this.formInline);
            let data = await Service.getUnbindingMeter(form);
            if(data) {
                let list = data.list == null ? [] : data.list;
                this.tableData = this.fmtData(list);
                this.total = data.total;
            }
        },
        fmtOnlineStatus(row){
            return funFmtOnlineStatus(row.online_status)
        }
    }
}

</script>
<style lang='less' scoped>

</style>